<div class="content" *ngIf="isOpen">
  <div class="process-modal-overlay">
    <div class="process-modal">
      <mat-icon class="close-modal" (click)="close()">close</mat-icon>
      <!-- Timer Display -->
      <div class="timer-display">
        <!-- {{ timerMinutes }}:{{ timerSeconds | number: '2.0' }} -->
        {{ doCaseTimer }}
      </div>
      <form [formGroup]="formulario">
        <mat-tab-group animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="tab-label-flex">
                <span class="titulo-tabs">Alerta en proceso</span>
                <span class="tab-label-gai">{{ alert.gai }}</span>
              </div>
            </ng-template>
            <div class="process-modal-content">
              <!-- Sección de campos de texto -->
              <div class="row">
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput type="text" formControlName="nombre" required readonly />
                    <mat-error *ngIf="formulario.get('nombre').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Apellido</mat-label>
                    <input matInput type="text" formControlName="apellido" required readonly />
                    <mat-error *ngIf="formulario.get('apellido').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Documento</mat-label>
                    <input matInput type="text" formControlName="cedula" required readonly />
                    <mat-error *ngIf="formulario.get('cedula').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Cliente</mat-label>
                    <input matInput type="text" formControlName="nombreCliente" required readonly />
                    <mat-error *ngIf="formulario.get('nombreCliente').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Teléfono de contacto</mat-label>
                    <input matInput type="text" formControlName="telefono" required readonly />
                    <mat-error *ngIf="formulario.get('telefono').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Instrumento</mat-label>
                    <input matInput type="text" formControlName="instrumento" required readonly />
                    <mat-error *ngIf="formulario.get('instrumento').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Canal</mat-label>
                    <input matInput type="text" formControlName="canal" required readonly />
                    <mat-error *ngIf="formulario.get('canal').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Monto</mat-label>
                    <input matInput type="text" [value]="
                        formulario.get('monto').value | number : '1.2-2' : 'es'
                      " required readonly />
                    <mat-error *ngIf="formulario.get('monto').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="observacion" required style="height: 50px"></textarea>
                    <mat-error *ngIf="formulario.get('observacion').invalid">
                      Este campo es requerido
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <label>Estado del contacto</label>
              <mat-radio-group class="radio-group" formControlName="estadoContacto">
                <mat-radio-button color="primary" value="1">Cliente localizado</mat-radio-button>
                <mat-radio-button value="2">Cliente no localizado</mat-radio-button>
              </mat-radio-group>

              <div class="form-section response-section"
                [class.visible]="formulario.get('estadoContacto').value === '1'">
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline">
                      <mat-label>Respuesta</mat-label>
                      <mat-select formControlName="respuesta">
                        <mat-option *ngFor="let ops of operation" [value]="ops.id">
                          {{ ops.nombre }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="formulario.get('respuesta').invalid">
                        Este campo es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div *ngIf="formulario.get('respuesta').value === 'rechazar'">
                <div>
                  <mat-checkbox class="custom-checkbox" formControlName="cuentaMultiTitular">
                    Condicionar la cuenta
                  </mat-checkbox>
                </div>
                <div class="aprobarAlertButton">
                  <button mat-raised-button class="tertiary-btn btn-process-save" (click)="saveAlert()"
                    [disabled]="!formValid">
                    Aprobar alerta
                  </button>
                </div>
              </div>
            </div>

            <div class="process-modal-actions" *ngIf="isDivVisible">
              <!-- <button mat-stroked-button class="btn-process-cancel" (click)="close()">Cancelar</button> -->
              <button mat-raised-button class="tertiary-btn btn-process-save" (click)="onSave()"
                [disabled]="!formValid">
                Finalizar
              </button>
            </div>
          </mat-tab>
        </mat-tab-group>
      </form>
    </div>
  </div>
</div>